import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

const SOULS = msg({ message: "{cost, plural, one {# soul} other {# souls}}" });

type SoulsCostProps = {
  cost: number;
};

// Цена в душах — цветом душ и ромбиком, как в магазине игры; слово «душ» — для экранного диктора.
export const SoulsCost = ({ cost }: SoulsCostProps) => {
  const { i18n } = useLingui();
  return (
    <span
      role="img"
      aria-label={i18n._({ ...SOULS, values: { cost } })}
      className="inline-flex items-center gap-1 font-mono font-semibold text-souls"
    >
      <svg width="10" height="13" viewBox="0 0 11 14" aria-hidden="true">
        <path d="M5.5 0L11 7l-5.5 7L0 7z" fill="currentColor" />
        <path d="M5.5 3L8 7l-2.5 4L3 7z" className="fill-background" opacity="0.35" />
      </svg>
      {new Intl.NumberFormat(i18n.locale).format(cost)}
    </span>
  );
};
